module.exports = __webpack_public_path__ + "img/GR039N.1ef08040.svg";